import React from 'react';
import './CEtsyReviewsBanner.css';
import {withTranslation} from "react-i18next";
import * as PropTypes from "prop-types";

function sanitizeText(text) {
    return text.replace(/\uFFFD+/g, ""); // Supprime uniquement les caractères "�"
}

// Composant pour afficher une seule revue
class SingleReview extends React.Component {
    render() {
        let {review, t, renderStars} = this.props;
        const showImage = false;
        return (
            <div className={`avis-item ${!review.image_url_fullxfull ? 'no-image' : ''}`}>
                <table>
                    <tbody>
                    <tr>
                        <td>
                            <div className="avis-note">{renderStars(review.rating)}</div>
                            <p className="avis-commentaire">"{sanitizeText(review.review)}"</p>
                            <p className="avis-date">
                                {new Date(review.create_timestamp * 1000).toLocaleDateString('fr-FR')}
                                &#160;
                                {t('home.byACustomer')} ({review.language})</p>
                        </td>
                        <td>&#160;
                            {review.image_url_fullxfull && showImage && (
                                <img src={review.image_url_fullxfull} alt="Avis / Review" className="avis-image" />
                            )}
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        );
    }
}

SingleReview.propTypes = {
    review: PropTypes.any,
    t: PropTypes.any,
    renderStars: PropTypes.any
}

const CEtsyReviewsBanner = ({t, reviews}) => {
    // console.log("reviews", reviews)
    if (!reviews || reviews.length === 0) {
        return null;
    }

    const getRandomReviews = (reviews) => {
        const shuffled = [...reviews].sort(() => 0.5 - Math.random());
        return shuffled.slice(0, 5);
    };

    const selectedReviews = getRandomReviews(reviews);

    const renderStars = (rating) => {
        const stars = [];
        for (let i = 0; i < 5; i++) {
            stars.push(
                <svg
                    key={i}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    fill={i < rating ? '#FFD700' : '#E0E0E0'}
                >
                    <path
                        d="M12 .587l3.668 7.431 8.2 1.192-5.934 5.782 1.4 8.168L12 18.896l-7.334 3.864 1.4-8.168L.132 9.21l8.2-1.192z"/>
                </svg>
            );
        }
        return stars;
    };

    return (<>
        <h2 className="alignCenter">{t('home.customerReviews')}</h2>
        <div className="avis-bandeau">
            {selectedReviews.map((review, index) => (
                <SingleReview key={index} review={review} t={t} renderStars={renderStars}/>
            ))}
        </div>
        <div className={"floatRight"}><i>{t('home.fromEtsy')}</i></div>
        <div className={"clear"}>&#160;</div>
    </>);
};

export default withTranslation('common')(CEtsyReviewsBanner);